import { FC } from 'react';
import { useTheme } from '@material-ui/core';
import ListIcon from '@material-ui/icons/List';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import {
  WbDivider,
  WbViewTabs,
  WbViewTabItem,
} from '@agilelab/plugin-wb-platform';

export const BlueprintListTypeButtons: FC = () => {
  const theme = useTheme();

  return (
    <div
      style={{
        display: 'flex',
        gap: theme.spacing(1),
        marginLeft: theme.spacing(1),
        alignItems: 'baseline',
        paddingTop: theme.spacing(0.3),
      }}
    >
      <WbDivider orientation="vertical" />
      <WbViewTabs aria-label="Display mode">
        <WbViewTabItem
          value="grid"
          icon={<ViewModuleIcon style={{ fontSize: 16 }} />}
          aria-label="Grid"
        />
        <WbViewTabItem
          value="table"
          icon={<ListIcon style={{ fontSize: 16 }} />}
          aria-label="Table"
        />
      </WbViewTabs>
    </div>
  );
};
